<template>
  <div>
    <b-form-group
      :state="customerState"
      :invalid-feedback="customerError"
    >
      <label for="name">Ügyfél</label>
      <b-input-group>
        <b-form-select
          v-model="id"
          :state="customerState"
          :options="customers"
        />
        <b-input-group-append class="ml-2">
          <b-button-group>
            <b-button
              variant="warning"
              size="sm"
              :disabled="id === -1"
              @click="editCustomer"
            >
              <i class="fas fa-edit" />
              <span>Szerkesztés</span>
            </b-button>
            <b-button
              variant="success"
              size="sm"
              @click="addCustomer"
            >
              <i class="fas fa-plus" />
              <span>Új ügyfél</span>
            </b-button>
          </b-button-group>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <customer-edit-modal
      :show.sync="showCustomer"
      :customer-id.sync="editedCustomer"
      @change="customerChanged"
      @add="customerAdded"
    />
  </div>
</template>
<style>
  #actions { padding-top: 2px; }
</style>
<script>
  import CustomerEditModal from './CustomerEditModal'

  export default {
    components: {
      'customer-edit-modal': CustomerEditModal
    },
    props: {
      customerId: {
        type: Number,
        required: true
      },
      customerState: {
        type: Boolean,
        required: true
      },
      customerError: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        customers: [
          {value: -1, text: 'Válassz egy ügyfelet'}
        ],
        id: -1,
        editedCustomer: -1,
        showCustomer: false
      }
    },
    watch: {
      customerId: function(id) {
        this.id = id
      },
      id: function(id) {
        this.$emit('update:customerId', id)
      }
    },
    mounted() {
      this.$http.get(this.$url('api.customers.index'))
      .then(({data}) => {
        if(data.customers) {
          _.forEach(data.customers, customer => this.customers.push({text: customer.name, value: customer.id}))
        }
      })
    },
    methods: {
      addCustomer() {
        this.editedCustomer = -1
        this.showCustomer = true
      },
      editCustomer() {
        this.editedCustomer = this.id
        this.showCustomer = true
      },
      customerChanged(changed) {
        var customer = _.find(this.customers, customer => customer.value === changed.id)
        customer.text = changed.name
      },
      customerAdded(customer) {
        this.customers.push({value: customer.id, text: customer.name})
        this.id = customer.id
      }
    }
  }
</script>